import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgListen = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 17 25" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g stroke="#17181A" fill="none" fillRule="evenodd">
      <path d="M2.118 8.178c.793-4.616 3.136-6.924 7.03-6.924 5.841 0 6.49 6.16 6.49 7.879 0 1.718-1.376 4.533-2.876 6.197-1 1.109-2.294 3.173-3.884 6.191-1.04 1.779-2.279 2.668-3.714 2.668-2.154 0-4.098-1.646-4.098-4.618" />
      <path d="M12.773 8.266c-.503-2.719-1.806-4.078-3.908-4.078s-3.437.944-4.005 2.83c.09 1.214-.154 2.107-.733 2.68-.87.86-1.29 1.807 0 2.508 1.29.7 1.466 1.862.733 2.612s-2.54 2.11.733 3.705" />
    </g>
  </svg>
);
const Memo = memo(SvgListen);
export default Memo;
